import _ from 'lodash';
import { toSearchableString /* sortNumber, sortString */ } from 'app/utils';

const TEMPLATE_NAME = 'NANDA_CLASS';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filters: {
    term: '',
    data: []
  }
});

// const sort = function (a, b) {
//   let result = sortNumber(a.status, b.status);
//   if (result !== 0) {
//     return result;
//   }
//   const aNandaClass = a.NANDACode || null;
//   const bNandaClass = b.NANDACode || null;
//   result = sortString(aNandaClass, bNandaClass);
//   if (result !== 0) {
//     return result;
//   }
//   return sortString(a.key, b.key);
// };

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterData = (data, term) => {
  const result = data.filter(item => {
    const NANDACode = item.NANDACode ? filterByTerm(item.NANDACode, term) : false;
    const name = item.name ? filterByTerm(item.name, term) : false;
    const description = item.description ? filterByTerm(item.description, term) : false;

    return NANDACode || name || description;
  });
  // if (sort) {
  //   result.sort(sort);
  // }

  return result;
};

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      return {
        ...state,
        loading: false,
        loadedData: newData,
        filters: {
          ...state.filters,
          data: filterData(newData, state.filters.term)
        }
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: [...currentData, ...newData],
        filters: {
          ...state.filters,
          data: filterData(
            !_.isEmpty(newData) ? [...currentData, ...newData] : currentData,
            state.filters.term
          )
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
      const { data, searchTerm } = action.payload;

      return {
        ...state,
        loading: false,
        filters: {
          ...state.filters,
          data: filterData(data, searchTerm)
        }
      };
    }

    default:
      return state;
  }
};

export default reducer;
